import { LoginResultDTO } from '@/api/dto/LoginResultDTO';
import { $httpNoAuth as $http } from '@/api/common/AxiosNoAuth';
import { getAuthURL, getInfoURL } from '@/api/utils/baseURLs';
import { ShopifyCredsDTO } from '../dto/ShopifyCredsDTO';

export class AuthEndpoint {
  public async login(userName: string, password: string): Promise<LoginResultDTO> {
    let loginResponse;

    try {
      const data = {
        userName: userName,
        password: password,
      };

      //required for current implementation, but payload not used
      loginResponse = await $http.post(`/Auth/login`, data, { baseURL: getAuthURL() });
    } catch (err) {
      if (err instanceof Error) {
        console.error('Login error', err.message);
      }
      throw err;
    }
    try {
      const tokenResponse = await $http.post(
        `/Auth/gettoken`,
        {},
        { baseURL: getAuthURL() },
      );

      //add correct authorization token for all requests
      $http.interceptors.request.use(function(config) {
        config.headers.LiveArtAuthorization = `Bearer ${tokenResponse.data}`;
        return config;
      });

      return { token: tokenResponse.data };
    } catch (err) {
      console.error(err);
      //  do nothing
    }

    return { token: loginResponse.data.token };
  }

  public async logout() {
    try {
      await $http.post(`/Auth/logout`, {}, { baseURL: getAuthURL() });

      //remove authorization token for all requests
      $http.interceptors.request.use(function(config) {
        config.headers.Authorization = undefined;
        config.headers.LiveArtAuthorization = undefined;
        return config;
      });
    } catch (err) {
      if (err instanceof Error) {
        console.error('Login error', err.message);
      }
      throw err;
    }
  }

  public async getShopifyCreds(): Promise<ShopifyCredsDTO> {
    try {
      const response = await $http.get(`/getinfo`, { baseURL: getInfoURL() });
      return response.data;
    } catch (err) {
      if (err instanceof Error) {
        console.error('Shopify Creds error', err.message);
      }
      throw err;
    }
  }
}
